import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import Page from 'src/components/common/Page';
import Panel from 'src/components/common/Panel';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import { IRootState } from 'src/reducers';
import PersonnelSearch from '../components/PersonnelSearch';
import BenefitsPageDocs from './BenefitsPageDocs';
import actions from 'src/actions';
import DialogList from 'src/dialogs';
import Personnel from 'src/models/personnel/Personnel';
import PersonnelBenifitFormData from 'src/models/personnel/PersonnelBenefitFormData';
import useFetch from 'use-http';
import PersonnelNavBar from '../components/PersonnelNavBar';
import PagedResultSet from 'src/models/common/PagedResultSet';
import State from 'src/models/State';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';

const BenefitsPage = () => {
    const selectedPersonnel = useSelector((state: IRootState) => state.landman.selectedPersonnel);
    const [states, setStates] = useState<PagedResultSet<State>>(undefined);
    const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
    const dispatch = useDispatch();
    const { register, errors, setValue, handleSubmit, reset } = useForm<PersonnelBenifitFormData>();
    const { get, put, response } = useFetch();

    // Initial render
    useEffect(() => {
        onCreate();

        return () => {
            onDestroy();
        };
    }, []);

    useEffect(() => {
        onCreate();
    }, [selectedPersonnel]);

    const onCreate = () => {
        if (selectedPersonnel) {
            reset(selectedPersonnel);
        }
        console.log('BenefitsPage onCreate()');

        setValue('paperwork[0].docs', 5);
        setValue('paperwork[1].docs', 11);
        setValue('paperwork[2].docs', 15);
        setValue('paperwork[3].docs', 9);
        setValue('paperwork[4].docs', 8);
        setValue('paperwork[5].docs', 6);
        setValue('paperwork[6].docs', 0);
        setValue('paperwork[7].docs', 1);

        setValue('insurance[0].docs', 15);
        setValue('insurance[1].docs', 5);
        setValue('insurance[2].docs', 2);

        getStates();
    };

    const onDestroy = () => {
        console.log('BenefitsPage onDestroy()');
    };

    const getStates = async () => {
        let result = await get('/v1.0/states');

        if (response.ok) {
            result.items.splice(0, 0, {id: 0, name: 'DO NOT WITHHOLD', abbreviation: 'DNW'});
            setStates(result);
        } else {
            console.log('Unable to get the States Data!!!');
        }
    };

    const stateDropdownOptions = () => {
        return states
            ? states?.items?.map((st: State) => {
                return { value: st.name, label: st.name };
            })
            : [];
    };

    const printReminder = () => {
        console.log('Print Reminder Clicked');
    };

    const selectAll = () => {
        console.log('Select All Clicked');
    };

    // const deSelectAll = () => {
    //     console.log('Deselect All Clicked');
    // };

    const displayTitle = () => {
        const title = selectedPersonnel ? `Paperwork - ${selectedPersonnel?.firstName} ${selectedPersonnel?.lastName}` : 'Paperwork';

        return title;
    };

    const showPersonnelData = () => {
        console.log('Display the Stuffs');
    };

    const displayPaperwork = () => {
        return <div>
            {/* <table>
                <tr>
                    <th style={{ textAlign: 'start' }}>Document Name</th>
                    <th>Comp. Date</th>
                    <th style={{ textAlign: 'right' }}>Docs</th>
                </tr>
                {paperwork.map((val, key) => {
                    return (
                        <tr key={key}>
                            <td style={{ width: '70%' }}>
                                {val.name}
                            </td>
                            <td style={{ width: '20%' }}>
                                <RHFInputBox
                                    name={`paperwork[${key}].completedDate`}
                                    type="date"
                                    defaultVal={val.completedDate}
                                    errors={errors}
                                />
                            </td>
                            <td style={{ width: '10%' }}>
                                <RHFInputBox
                                    name={`paperwork[${key}].docs`}
                                    type="number"
                                    errors={errors}
                                    style={{ textAlign: 'right' }}
                                />
                            </td>
                        </tr>
                    );
                })}
            </table> */}

            {selectedPersonnel && <BenefitsPageDocs
                showDialog={showDialog}
                hideDialog={hideDialog}
                hasOwnership={false}
                userId={selectedPersonnel ? selectedPersonnel.id : null}
            />}
        </div>;
    };

    const finalizeData = (data: PersonnelBenifitFormData) => {
        const finalData: Personnel = {
            ...selectedPersonnel,
            withholdState: data.withholdState,
            monopolisticState: data.monopolisticState

        };
        return finalData;
    };

    const onSubmit = (data: PersonnelBenifitFormData) => {
        const finalData = finalizeData(data);
        updatePersonnel(finalData);
        console.log('Submitted the form', finalData);
    };

    const updatePersonnel = async (data: Personnel) => {
        let result = await put(`/v1.0/landmen/${data.id}/save-personnel`, data);

        if (response.ok) {
            window.alert('Update successful');
        } else if (result?.messageCode === '15') {
            window.alert('Update failed');
        } else {
            window.alert('Update Personnel failed');
        }
    };

    const showDialog = (dialog: DialogList) => {
        dispatch(actions.layout.showDialog(dialog));
    };
    
    const hideDialog = () => {
        dispatch(actions.layout.hideDialog());
    };

    const flipActivation = async () => {
        await put(`/v1.0/users/${selectedPersonnel?.id}/toggle-status`);

        if (response.ok) {
            window.alert('User Status has been updated.');

        } else {
            window.alert('Activating/Deactivating user failed');
        }
    };

    return (
        <div>
            <PersonnelNavBar/>
            <PersonnelSearch showPersonnelData={showPersonnelData} setIsCollapsed={setIsCollapsed} />
            <Page>
                <Page.Section width={6}>
                    <Panel backgroundColor="#D3D3D3">
                        <Panel panelTitle={displayTitle()}>
                            {selectedPersonnel && <div className={isCollapsed ? 'large-panel' : 'large-panel-with-search'} style={{ overflowY: 'scroll' }}>
                                {/* Commented out for potential future unremoval */}
                                {/* <div style={{ textAlign: 'center' }}>
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '30%' }}
                                        text={'Paperwork Comments'}
                                        onClick={() => printReminder()}
                                    />
                                </div> */}
                                <div style={{ padding: '2rem', whiteSpace: 'nowrap' }}>
                                    {displayPaperwork()}
                                </div>
                                {/* <div className="form-row">
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '30%', marginLeft: '2rem', marginRight: '1rem' }}
                                        text={'Print Reminder'}
                                        onClick={() => printReminder()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '30%', marginRight: '1rem' }}
                                        text={'Select All'}
                                        onClick={() => selectAll()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '30%', marginRight: '1rem' }}
                                        text={'Deselect All'}
                                        onClick={() => deSelectAll()}
                                    />
                                </div> */}
                            </div>}
                            {!selectedPersonnel && <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '20px', padding: '3rem' }}>
                                No Personnel Selected
                            </div>}
                        </Panel>
                    </Panel>
                </Page.Section>
                <Page.Section width={6}>
                    <Panel backgroundColor="#D3D3D3">
                        <Panel panelTitle={`User Account Maintenance`}>
                            {selectedPersonnel && <div className={isCollapsed ? 'large-panel' : 'large-panel-with-search'} style={{ overflowY: 'scroll' }}>
                                {/* <div style={{ textAlign: 'center' }}>
                                    <h2 className="legend-title" style={{ margin: '0rem' }}>User Account Maintenance</h2>
                                </div> */}
                                <div style={{ padding: '2rem' }}>
                                    <RHFInputBox
                                        name={`username`}
                                        label="Username"
                                        type="text"
                                        register={register}
                                        errors={errors}
                                        bodyStyle={{ width: '100%' }}
                                        style={{ textAlign: 'right', width: '100%' }}
                                        disabled={true}
                                    />
                                    {/* <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                        <div style={{ marginTop: '1rem' }}>Account Status:</div>
                                        <RHFCheckbox
                                            name="isActive"
                                            label="Active"
                                            bodyStyle={{ marginTop: '2rem', marginLeft: '1rem' }}
                                            register={register}
                                            errors={errors}
                                            disabled={true}
                                        />
                                        <RHFCheckbox
                                            name="doNotCall"
                                            label="Do Not Call"
                                            bodyStyle={{ marginTop: '2rem', marginLeft: '1rem' }}
                                            register={register}
                                            errors={errors}
                                            disabled={true}
                                        />
                                    </div> */}
                                </div>
                                <div className="form-row">
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '30%', marginLeft: '2rem', marginRight: '1rem' }}
                                        text={'Add Account'}
                                        onClick={() => printReminder()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '30%', marginRight: '1rem' }}
                                        text={'Reset Password'}
                                        onClick={() => selectAll()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '30.5%' }}
                                        text={'Activate/Deactivate'}
                                        onClick={() => flipActivation()}
                                    />
                                </div>
                                <div className="form-row">
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '30%', marginLeft: '2rem', marginRight: '1rem' }}
                                        text={'Transfer Existing Account'}
                                        onClick={() => printReminder()}
                                    />
                                    <Button
                                        className="blue-hover-button"
                                        style={{ width: '30%', marginRight: '1rem' }}
                                        text={'Role Maintenance'}
                                        onClick={() => selectAll()}
                                    />
                                    {/* <Button
                                        className="blue-hover-button"
                                        style={{ width: '30.5%' }}
                                        text={'Add/Remove Blacklist'}
                                        onClick={() => deSelectAll()}
                                    /> */}
                                </div>
                                <div style={{ textAlign: 'center', marginTop: '3rem' }}>
                                    <h2 className="legend-title">Workers' Comp</h2>
                                </div>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <div className="form-row" style={{ padding: '2rem' }}>
                                        <RHFSelect
                                            name={`withholdState`}
                                            label="Withhold State"
                                            labelOnLeft={true}
                                            labelStyle={{width: '20rem'}}
                                            register={register}
                                            errors={errors}
                                            options={stateDropdownOptions()}
                                            bodyStyle={{ width: '49%' }}
                                            style={{ width: '100%' }}
                                        />
                                        <RHFInputBox
                                            name={`monopolisticState`}
                                            label="Monopolistic State"
                                            labelOnLeft={true}
                                            labelStyle={{width: '25rem'}}
                                            type="text"
                                            register={register}
                                            errors={errors}
                                            bodyStyle={{ width: '49%' }}
                                            style={{ textAlign: 'right', width: '100%' }}
                                        />

                                    </div>
                                    <div style={{ textAlign: 'center' }}>
                                        <Button
                                            className="blue-hover-button"
                                            style={{ width: '30%' }}
                                            text="Save"
                                            type="submit"
                                        />
                                    </div>
                                </form>
                            </div>}
                            {!selectedPersonnel && <div style={{ textAlign: 'center', fontWeight: 'bold', fontSize: '20px', padding: '3rem' }}>
                                No Personnel Selected
                            </div>}
                        </Panel>
                    </Panel>
                </Page.Section>
            </Page>
        </div>
    );
};

export default BenefitsPage;



// WEBPACK FOOTER //
// ./src/components/personnel/pages/PaperworkAccessPage.tsx